import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import { getIsGetUserInfoLoading } from 'store/user/selectors';
import { GlobalLoadingWrapper } from 'helpers/routing/styles';

const PrivateRoute = ({ component: Component, ...rest }: any) => {
  const isLoading = useSelector(getIsGetUserInfoLoading);
  return (
    <Route
      {...rest}
      render={(props) =>
        isLoading ? (
          <GlobalLoadingWrapper>
            <CircularProgress data-testid="loader" size={50} />
          </GlobalLoadingWrapper>
        ) : isEmpty(localStorage.getItem('token')) ? (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location },
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PrivateRoute;
